var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOpenWindow = function SvgOpenWindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3C3.44772 3 3 3.44772 3 4V12C3 12.5523 3.44772 13 4 13H12C12.5523 13 13 12.5523 13 12V8H15V12C15 13.6569 13.6569 15 12 15H4C2.34315 15 1 13.6569 1 12V4C1 2.34315 2.34315 1 4 1H8V3H4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8182 7.27273V0H8.54545L10.7273 2.18182L6 6.90909L8.90909 9.81818L13.6364 5.09091L15.8182 7.27273Z"
  })));
};

export { SvgOpenWindow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgM0MzLjQ0NzcyIDMgMyAzLjQ0NzcyIDMgNFYxMkMzIDEyLjU1MjMgMy40NDc3MiAxMyA0IDEzSDEyQzEyLjU1MjMgMTMgMTMgMTIuNTUyMyAxMyAxMlY4SDE1VjEyQzE1IDEzLjY1NjkgMTMuNjU2OSAxNSAxMiAxNUg0QzIuMzQzMTUgMTUgMSAxMy42NTY5IDEgMTJWNEMxIDIuMzQzMTUgMi4zNDMxNSAxIDQgMUg4VjNINFoiIC8+CjxwYXRoIGQ9Ik0xNS44MTgyIDcuMjcyNzNWMEg4LjU0NTQ1TDEwLjcyNzMgMi4xODE4Mkw2IDYuOTA5MDlMOC45MDkwOSA5LjgxODE4TDEzLjYzNjQgNS4wOTA5MUwxNS44MTgyIDcuMjcyNzNaIi8+Cjwvc3ZnPgo=";